<template>
  <v-container fluid>
    <v-data-table
        class="no-select-table"
        :loading="portionLoading"
        :loading-text="$t('statements.loadingText')"
        :items="statementsList || []"
        :headers="headers"
        :items-per-page.sync="itemsPerPage"
        :page.sync="currentPage"
        item-key="id"
        :footer-props="{itemsPerPageOptions: [10, 25, 50], pageText: continuosAmount ? `{0} / ${statementsList.length -  1}+` : '$vuetify.dataFooter.pageText'}"
    >
    <!--
        :expanded.sync="expandedRows"
        @click:row="openDetails"
        show-expand
    -->

      <template v-slot:expanded-item="{headers, item}">
        <td :colspan="headers.length">
          <v-container v-if="item">
            <v-row>
              <v-col cols="4">
                <table class="statement-table">
                  <tbody>
                  <tr
                      v-for="col in ['grossAmount', 'administrativeCharge', 'netAmount', 'serviceVAT', 'grossVAT', 'amountPaid']"
                      :key="col"
                  >
                    <td>{{  $t(`statements.columns.${col}`) }}</td>
                    <td>{{ item[col] | nf }}</td>
                  </tr>
                  </tbody>
                </table>
              </v-col>

              <v-col cols="4">
                <table class="statement-table">
                  <tbody>
                  <tr v-for="col in ['invoiceNumber', 'invoiceDateFormatted', 'paymentDateFormatted', 'paidTo']" :key="col">
                    <td>{{ $t(`statements.columns.${col}`) }}</td>
                    <td>{{ item[col] }}</td>
                  </tr>
                  </tbody>
                </table>
              </v-col>
            </v-row>
          </v-container>
        </td>
      </template>

      <template v-slot:item.amountPaid="{item}">
        <span v-if="item && item.utbk">{{ item.utbk | nf }}</span>
        <span v-else>-</span>
      </template>

      <template v-slot:item.actions="{item}">
        <div class="text-end">
          <v-btn @click.stop="downloadDetails(item)" text color="primary">
            <v-icon left>mdi-file-pdf-outline</v-icon>
            {{ $t('statements.details') }}
          </v-btn>
          <v-btn @click.stop="downloadPlaylist(item)" text color="primary">
            <v-icon left>mdi-file-excel-outline</v-icon>
            {{ $t('statements.playlist') }}
          </v-btn>
        </div>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import {mapGetters} from "vuex";
import downloadFile from "@/utils/downloadFile";
import RightsholderInitedDataDrivenMixin from "@/components/mixins/RightsholderInitedDataDrivenMixin";

export default {
  name: 'Statements',
  data() {
    return {
      expandedRows: [],
      itemsPerPage: 50,
      currentPage: 1,
      portionLoading: false,
    }
  },
  mixins: [RightsholderInitedDataDrivenMixin],
  computed: {
    ...mapGetters('app', ['statements']),
    headers() {
      const getHeader = (value) => ({value, text: this.$t(`statements.columns.${value}`)});
      return [
        {text: '', value: 'data-table-expand'},
        getHeader('invoiceNumber'),
        getHeader('paymentDateFormatted'),
        getHeader('paidTo'),
        {...getHeader('amountPaid'), ...{align: 'end'}},
        {value: 'actions', text: null, sortable: false,}
      ]
    },
    continuosAmount() {
      return !this.statements.finished;
    },
    statementsList() {
      if (!this.statements.list) {
        return [];
      }
      return this.statements.list 
      //.concat(this.statements.finished ? [] : [null]);
    },
    lastPage() {
      return Math.ceil((this.statementsList.length - Number(this.continuosAmount)) / this.itemsPerPage);
    },
  },

  watch: {
    currentPage() {
      if (this.currentPage === (this.lastPage + 1)) {
        if (this.continuosAmount && this.lastPage > 0) {
          this.loadStatementsList()
        }
      }
    }
  },

  methods: {

    reloadItems() {
      this.loadStatementsList(true);
    },

    openDetails(item) {
      if (this.expandedRows.includes(item)) {
        this.expandedRows = this.expandedRows.filter(i => i !== item);
      } else {
        this.expandedRows.push(item);
      }
    },

    loadStatementsList(force = false) {
      if (force) {
        this.currentPage = 1;
      }

      this.portionLoading = true;
      this.$store.dispatch('app/loadStatements', {reload: force})
        .then(() => {
          this.portionLoading = false;
        });
    },

    downloadDetails(item) {
      this.$store.dispatch('app/downloadStatementDetails', item.invoiceNumber).then((blobUrl) => {
        downloadFile(`invoice_${item.invoiceNumber}.pdf`, blobUrl);
      })
    },

    downloadPlaylist(item) {
      this.$store.dispatch('app/downloadStatementPlaylist', item.invoiceNumber).then((blobUrl) => {
        downloadFile(`playlist_${item.invoiceNumber}.xlsx`, blobUrl);
      })
    }
  },

}
</script>

<style scoped lang="scss">
.statement-table {
  width: 100%;

  td:first-child {
    font-weight: bold;
    padding-right: 1em;
  }

  td:last-child {
    text-align: right;
  }
}
</style>